module.exports = __webpack_public_path__ + "img/smile.2b8a766.svg";